<template>
  <!-- 司机管理 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" inpBox">
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" v-model="searchFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder="" v-model="searchFrom.identityNo"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" v-model="searchFrom.mobile"></el-input>
              </el-form-item>
              <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="searchFrom.driverClassify">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:" prop="driverTenantName">
                <el-input  placeholder="" v-model="searchFrom.driverTenantName"></el-input>
              </el-form-item>
              <el-form-item label="起始地:" prop="startArea">
                <el-input  placeholder="" v-model="searchFrom.startArea"></el-input>
              </el-form-item>
              <el-form-item label="目的地:" prop="endArea">
                <el-input  placeholder="" v-model="searchFrom.endArea"></el-input>
              </el-form-item>
             <el-form-item label="创建时间:" prop="createTimes">
                    <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00IP001B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%"   style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" btnCode="00IP003B001"  v-if="btnFlg[0]" v-show="scope.row.tenantId==tenantCode" @click="lookFn(scope.row)">查看</el-button>
                </template>
        </el-table-column>
         <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="name" width="120" :formatter="emptyFn" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
        <el-table-column property="identityNo" label="身份证号" width="200">
          <template scope="scope">
           <p v-if="scope.row.tenantId!=tenantCode">
            {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
          </p>
          <p v-else>{{scope.row.identityNo}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" width="150" :formatter="emptyFn" label="联系电话"></el-table-column>
        <el-table-column property="driverClassify" label="司机所属" >
          <template scope="scope">
            {{scope.row.tenantId!=tenantCode?'市场司机':'自家司机'}}
          </template>
        </el-table-column>
        <el-table-column prop="driverTenantName" width="260" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属单位/个人"></el-table-column>
        <el-table-column property="licenseNum" label="驾驶证号" width="200">
          <template scope="scope">
           <p v-if="scope.row.tenantId!=tenantCode">
            {{scope.row.licenseNum.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
          </p>
          <p v-else>{{scope.row.licenseNum}}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="useLines" width="300" :show-overflow-tooltip="true" :formatter="emptyFn" label="常走路线"></el-table-column> -->
        <el-table-column prop="identityExpiringDate" width="170" :formatter="dateFormat"  label="身份证有效期"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 查看 -->
    <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="dialoglook" @close="closeDialog" width="1120px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <span>{{addFrom.identityNo}}</span>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <span>{{addFrom.name}}</span>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <span>{{addFrom.mobile}}</span>
              </el-form-item>
               <el-form-item label="司机所属:" prop="driverClassify">
               <span> {{addFrom.tenantId!=tenantCode?'市场司机':'自家司机'}}</span>
             </el-form-item>
              <el-form-item label="所属单位/个人:" prop="driverTenantName">
               <span>{{addFrom.driverTenantName}}</span>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
               <span>{{addFrom.licenseNum}}</span>
              </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                  <span>{{addFrom.certificateNum}}</span>
              </el-form-item>
              <el-form-item label="道路运输从业资格证:" label-width="200" prop="qualificationNum">
               <span>{{addFrom.qualificationNum}}</span>
              </el-form-item>
               <el-form-item label="常走路线:" prop="useLines">
               <div style="width:560px">{{addFrom.useLines}}</div>
              </el-form-item>
               <div class="box">
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                     <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>

        </div>
        </el-form>
      </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialoglook = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { cDlist, detailDriver } from '@/api/vgs-driver2.0'
export default {
  data () {
    return {
      tenantCode: '',
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      FKfrom: {
        SKlist: []
      },
      isEdits: [],
      isAdd: false,
      tableList: [],
      loading: 'false',
      addFrom: {},
      ktzhFrom: {},
      title: '新建司机信息',
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      imgList: [],
      newImgFlag: false,
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: true, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: true, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        bankCard: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bankCardUser: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ]
      },
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '市场司机'
        },
        {
          value: 2,
          label: '自家司机'
        }
      ],
      total: 0,
      value2: '',
      ids: [],
      dialogVisible: false,
      kztzVisible: false,
      dialoglook: false,
      disabled: false,
      hideUploadEditA: false,
      hideUploadEditB: false,
      hideUploadEditC: false,
      hideUploadEditD: false,
      btnFlg: [],
      btnIdArr: ['00IP003B001']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverTowTenant')
    this.getList(this.searchFrom)
    this.tenantCode = localStorage.getItem('tenantCode')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {

    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cDlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 查看
    lookFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = res
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.dialoglook = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改
    modifyDeiver (row) {
      this.title = '修改司机信息'
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
      this.addFrom = {}
      this.ktzhFrom = {}
      this.$refs.table.clearSelection()
      this.isEdits = []
      this.rules1 = []
      this.FKfrom.SKlist = []
      this.FKfrom.driverId = null
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.newImgFlag = false
      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = JSON.parse(JSON.stringify(row))
        if (row.identityPhoto1Url) {
          this.$set(this.img, 0, { status: 'ready', url: row.identityPhoto1Url })
          this.$set(this.imgList, 0, 1)
        }
        if (row.identityPhoto2Url) {
          this.$set(this.img1, 0, { status: 'ready', url: row.identityPhoto2Url })
          this.$set(this.imgList, 1, 1)
        }
        if (row.appendix1Url) {
          this.$set(this.img2, 0, { status: 'ready', url: row.appendix1Url })
          this.$set(this.imgList, 2, 1)
        }
        if (row.appendix2Url) {
          this.$set(this.img3, 0, { status: 'ready', url: row.appendix2Url })
          this.$set(this.imgList, 3, 1)
        }
        if (row.qualificationPhotoUrl) {
          this.$set(this.img4, 0, { status: 'ready', url: row.qualificationPhotoUrl })
          this.$set(this.imgList, 4, 1)
        }
        this.newImgFlag = true
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.isEdits = []
        res.cDriverBankCardList.forEach(item => {
          this.isEdits.push(false)
        })
        this.FKfrom.driverId = res.id
        this.dialogVisible = true
        this.isAdd = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {

    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;
}
</style>
